var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "#222",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.775 5.5C8.15 5.5 8.48 5.295 8.65 4.985L10.44 1.74C10.625 1.41 10.385 1 10.005 1H2.605L2.135 0H0.5V1H1.5L3.3 4.795L2.625 6.015C2.26 6.685 2.74 7.5 3.5 7.5H9.5V6.5H3.5L4.05 5.5H7.775ZM3.08 2H9.155L7.775 4.5H4.265L3.08 2ZM3.5 8C2.95 8 2.505 8.45 2.505 9C2.505 9.55 2.95 10 3.5 10C4.05 10 4.5 9.55 4.5 9C4.5 8.45 4.05 8 3.5 8ZM8.5 8C7.95 8 7.505 8.45 7.505 9C7.505 9.55 7.95 10 8.5 10C9.05 10 9.5 9.55 9.5 9C9.5 8.45 9.05 8 8.5 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.ff614c7e.svg";
export { ForwardRef as ReactComponent };